<template>
  <PreviewDocumentModal
    v-if="previewModalOpen"
    :open="previewModalOpen"
    @close-modal="previewModalOpen = false"
    :modal_config="selectedFile"
  />
  <PaperCard :has_header="false" class="mt-6">
    <template #body>
      <AsteriskNotice variant="info" size="medium" text="Optional" class="lg:mb-1" />
      <h3 class="text-strongest font-semibold text-lg font-inter">
        Upload accreditation documents
      </h3>
      <div class="text-strong text-sm py-4">
        <p class="font-inter font-medium">
          Regulation D Offerings require Phoenix to validate accreditation documentation which could
          be:
        </p>
      </div>
      <ul class="font-medium mb-4">
        <li v-for="bullet in accreditationBullets" class="flex gap-3 text-strong text-sm">
          <span class="h-1 w-1 rounded-full bg-strong mt-2 shrink-0"></span>
          <p class="font-inter">
            {{ bullet }}
          </p>
        </li>
      </ul>
      <div v-if="dataStore.accreditation_documents?.length > 0" class="mb-4">
        <div
          v-for="doc in dataStore.accreditation_documents"
          :key="doc.record_id"
          class="mb-2 flex flex-col lg:flex-row rounded-2xl bg-bg-canvas p-4 font-medium text-strongest justify-between lg:items-center w-full gap-4"
        >
          <div>
            <p class="font-inter text-sm lg:text-base truncate max-w-[300px] lg:max-w-none">
              {{ doc.file_name }}
            </p>
            <p class="text-xs font-inter text-strong">
              Created on {{ new Date(doc.created_date).toLocaleDateString() }}
            </p>
          </div>
          <div class="flex items-center gap-2">
            <Button @click="handlePreview(doc)" size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Eye" class="h-4 w-4" :stroke-width="2.5" />
              </template>
            </Button>
            <Button @click="downloadFile_R2(doc)" size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Download" class="h-4 w-4" :stroke-width="2.5" />
              </template>
            </Button>
            <Button @click="handleDeleteDoc(doc)" size="sm" variant="paper-primary">
              <template #icon>
                <Icon name="Trash2" class="h-4 w-4" :stroke-width="2.5" />
              </template>
              <template #label>Delete</template>
            </Button>
          </div>
        </div>
      </div>

      <FileDropper @files-selected="handleUploadAccreditationDocs" />
    </template>
  </PaperCard>
</template>

<script setup>
import { ref } from "vue";
import { PaperCard, FileDropper, AsteriskNotice, Button, Icon } from "@/components";
import { usePurchaseFlowStore, useDataStore, useUIStore } from "@/stores";
import useFileUtility from "@/composables/useFileUtility";
import PreviewDocumentModal from "../../InvestorDocuments/PreviewDocumentModal.vue";

const purchaseFlowStore = usePurchaseFlowStore();
const dataStore = useDataStore();
const UIStore = useUIStore();
const { downloadFile_R2, fetchFileForPreview_R2, deleteFile_R2 } = useFileUtility();

const previewModalOpen = ref(false);
const selectedFile = ref(null);

const accreditationBullets = [
  "A letter from CPA, Attorney, or Financial Professional with an active Series 7, Series 65, or Series 82 license.",
  "Proof of assets worth more than $1 million by reviewing specific types of documentation dated within the last 90 days, such as bank statements, brokerage statements, certificates of deposit, or tax assessments.",
  "Individual – Proof of income for 2 years of at least $200,000 by reviewing copies of any Internal Revenue Service form that reports income, such as Form W-2, Form 1099, Schedule K-1 of Form 1065, or a filed Form 1040.",
  "Joint – Proof of income for 2 years of at least $300,000 by reviewing copies of any Internal Revenue Service form that reports income, such as Form W-2, Form 1099, Schedule K-1 of Form 1065, or a filed Form 1040.",
];

async function handlePreview(file) {
  const fileUrl = await fetchFileForPreview_R2(file);
  selectedFile.value = { record: file, file_url: fileUrl };
  previewModalOpen.value = true;
}

async function handleUploadAccreditationDocs(files) {
  UIStore.is_loading = true;
  await purchaseFlowStore.uploadAccreditationDocs(files);
  UIStore.is_loading = false;
}

async function handleDeleteDoc(doc) {
  dataStore.accreditation_documents = dataStore.accreditation_documents.filter(
    (d) => d.record_id !== doc.record_id
  );
  dataStore.documents = dataStore.documents.filter((d) => d.record_id !== doc.record_id);
  await deleteFile_R2(doc);
}
</script>
